module.exports = {"apiUrl":"%API_URL%","cmsUrl":"%CMS_URL%"}


//////////////////
// WEBPACK FOOTER
// ./src/Config/prod-config.json
// module id = 1081
// module chunks = 0